import styled from 'styled-components';
import BusinessInfoPopoverContent from './BusinessInfoPopoverContent';
import PopoverInfoBox from './PopoverInfoBox';
import ContactUsPopoverContent from './ContactUsPopoverContent';

const InfoBox = () => {
  return (
    <Container>
      <PopoverInfoBox content={<BusinessInfoPopoverContent />} buttonText='Business Info' />
      <PopoverInfoBox content={<ContactUsPopoverContent />} buttonText='Contact Us' />
    </Container>
  );
};

export default InfoBox;

const Container = styled.div`
  position: sticky;
  bottom: 0;
  left: 0;
  margin-left: -17px;
  display: flex;
`;
